const PLACES = ["Cirencester", "Tetbury", "Bibury", "Stow-on-the-Wold", "Burford", "Malmesbury", "Painswick", "Cheltenham", "Chipping Campden", "Fairford", "Stroud", "Lechlade"];

export default function Marquee() {
  const row = [...PLACES, ...PLACES];
  return (
    <div aria-hidden="true" className="overflow-hidden border-y border-stone bg-paper py-6" data-testid="places-marquee">
      <div className="marquee-track">
        {row.map((p, i) => (
          <span key={i} className="flex items-center whitespace-nowrap font-serif text-3xl italic text-charcoal/80 sm:text-4xl">
            {p}<span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-forest/60 not-italic" />
          </span>
        ))}
      </div>
    </div>
  );
}
